document.addEventListener("DOMContentLoaded", function () {
  const searchIcons = document.querySelectorAll("[data-popdown-toggle='search-popdown']");

  console.log("smart search loaded");

  searchIcons.forEach((icon) => {
    icon.addEventListener("click", function () {
      const rebuySmartSearch = document.querySelector("#searchInput");

      if (rebuySmartSearch) {
        rebuySmartSearch.addEventListener("input", (e) => {
          const quickViewBody = document.querySelector(".rebuy-quick-view__overlay-body");
          const quickViewContainer = document.querySelector(".rebuy-quick-view__container");
          const injectedSection = quickViewBody.querySelector(
            ".rebuy-quick-view__product-section.injected"
          );

          !injectedSection
            ? (quickViewBody.innerHTML += `
                      <div class="rebuy-quick-view__product-section injected" style="display: none;">
                        <p class="rebuy-quick-view__title">Recommended Products</p>
                        <div class="rebuy-quick-view__product-list rebuy-quick-view__product-grid-column-4">
                        </div>
                      </div>
                    `)
            : null;

          if (e.target.value.length < 3) {
            quickViewContainer.style.display = "block";

            if (injectedSection) {
              injectedSection.style.display = "none";
            }
          } else {
            quickViewContainer.style.display = "none";

            if(injectedSection) {
              injectedSection.style.display = "flex";
            }            

            // Call the debounced fetch function
            debouncedFetch(e);
          }
        });
      }
    });
  });

  // Every 200ms check for prices to convert
  setInterval(() => {
    const resultPagePrices = document.querySelectorAll(".rebuy-smart-search-results-page__product .rebuy-money span:last-of-type:not(.rebuy-money--converted)");
    const quickViewPrices = document.querySelectorAll(".rebuy-quick-view__product .rebuy-money span:last-of-type:not(.rebuy-money--converted)");
    const prices = [...resultPagePrices, ...quickViewPrices];
    
    prices.forEach((price) => {
      const priceValue = price.textContent;
      const priceValueNumber = parseInt(priceValue.replace(/\D/g, ""));
      const formattedPrice = formatPrice(priceValueNumber);
      price.innerHTML = formattedPrice;
      price.classList.add("rebuy-money--converted");
    });
  }, 200);
});

function formatPrice(price) {
  const correctPrice =
    Shopify.currency.active != "DKK" ? (price / 100) * Shopify.currency.rate : price / 100;
  const formattedPrice = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: Shopify.currency.active,
  }).format(Math.ceil(correctPrice));
  return formattedPrice;
}

// Debounce function
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

// Function to perform the fetch
function performFetch(e) {
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      "Rebuy-Api-Key": "b56a549ed0df90e131829adc87a7f897c4c0cb3d",
      "content-type": "application/json",
    },
    body: JSON.stringify({ searchTerm: e.target.value, pageSize: 4 }),
  };

  fetch("https://rebuyengine.com/api/v1/smart-search/search", options)
    .then((response) => response.json())
    .then((response) => {
      const productList = document.querySelector(
        ".rebuy-quick-view__product-section.injected .rebuy-quick-view__product-list"
      );
      productList.innerHTML = "";
      if (response.data.products.length === 0) {
        productList.innerHTML = "<p>No products found</p>";
      } else {
        response.data.products.forEach((product) => {
          const productHTML = `
            <div class="rebuy-quick-view__product">
              <a
                href="${product.url}?_rdiscovery-handle=${
            product.handle
          }&amp;_rdiscovery-smart-search-feature=Quick%20View&amp;_rdiscovery-search-term=${
            e.target.value
          }"
                rel="nofollow"
                class="rebuy-quick-view__image-link rebuy-smart-search__absolute-image-container"
              >
                <img
                  srcset="${product.images[0].url.replace(/\.(?=[^.]*$)/, "_320x.")} 320w, 
                          ${product.images[0].url.replace(/\.(?=[^.]*$)/, "_480x.")} 480w, 
                          ${product.images[0].url.replace(/\.(?=[^.]*$)/, "_640x.")} 640w,
                          ${product.images[0].url.replace(/\.(?=[^.]*$)/, "_960x.")} 960w,
                          ${product.images[0].url.replace(/\.(?=[^.]*$)/, "_1280x.")} 1280w"
                  alt="Image of ${product.name}"
                  class="rebuy-quick-view_image rebuy-smart-search__absolute-image rebuy-smart-search__absolute-image--zoomed"
                />
              </a>
              <div class="rebuy-quick-view__product-detail">
                <div class="rebuy-product-info">
                  <a
                    href="${product.url}?_rdiscovery-handle=${
            product.handle
          }&amp;_rdiscovery-smart-search-feature=Quick%20View&amp;_rdiscovery-search-term=${
            e.target.value
          }"
                    rel="nofollow"
                    class="rebuy-product-title"
                  >
                    ${product.name}
                  </a>
                  <div class="price">
                    <span class="rebuy-money">
                      <span class="sr-only">Price</span>
                      <span class="rebuy-money--converted">${formatPrice(product.price)}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          `;
          productList.innerHTML += productHTML;
        });
      }
    })
    .catch((err) => console.error(err));
}

// Debounced version of the fetch function
const debouncedFetch = debounce(performFetch, 500);
